import { Label } from "./ui/label";

const firstMatch = (s, opts) => {
  const t = (s || "").toLowerCase();
  const hits = opts.map((o) => [o, t.indexOf(o.toLowerCase())]).filter(([, i]) => i >= 0);
  return hits.sort((a, b) => a[1] - b[1])[0]?.[0] || "";
};

export const PvpChoiceField = ({ field, label, options, values, disabled, onChange }) => {
  const current = firstMatch(values[field], options);
  return (
    <div className="space-y-2" data-testid={`pvp-field-choice-${field}`}>
      <Label className="text-sm font-medium leading-snug block">{label}</Label>
      <div className="flex gap-2">
        {options.map((o) => (
          <button key={o} type="button" disabled={disabled} onClick={() => onChange({ ...values, [field]: o })}
            className={`px-4 py-1.5 text-sm border transition-colors ${current === o ? "bg-zinc-900 text-white border-zinc-900" : "border-zinc-400 hover:bg-zinc-100"}`}
            data-testid={`pvp-${field}-${o.toLowerCase()}`}>{o}</button>
        ))}
      </div>
    </div>
  );
};
